import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import CopyIcon from 'assets/svgr-icons/Copy.svg'
import Tooltip from 'components/Tooltip'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { IPromptProps } from './types'
import * as Styled from './styled'

export const PROMPT_SCROLL_HEIGHT_THRESHOLD = 40

const AIPromptText: React.FC<IPromptProps> = ({
  isInitiallyExpanded = false,
  onClick,
  promptText
}) => {
  const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded)
  const [promptRef, setPromptRef] = useState<HTMLDivElement | null>(null)

  const isExpandable = useMemo(() => {
    return (promptRef?.scrollHeight || 0) > PROMPT_SCROLL_HEIGHT_THRESHOLD
  }, [promptRef])

  const onExpand = useCallback(() => {
    if (isExpandable) {
      setIsExpanded(!isExpanded)
      onClick?.()
    }
  }, [isExpanded, onClick, isExpandable])

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(promptText)
  }, [promptText])

  useEffect(() => {
    return () => {
      setIsExpanded(false)
    }
  }, [promptText])

  return (
    <Styled.Container>
      <Styled.PromptText
        key={promptText}
        ref={setPromptRef}
        onClick={onExpand}
        $scrollHeight={promptRef?.scrollHeight}
        $isExpanded={isExpanded}
        $isExpandable={isExpandable}
      >
        {promptText}
      </Styled.PromptText>
      <Tooltip tooltipText={translate(T.COPY_PROMPT_TOOLTIP)}>
        <Styled.CopyButton onClick={copyToClipboard}>
          <CopyIcon />
        </Styled.CopyButton>
      </Tooltip>
    </Styled.Container>
  )
}

export default memo(AIPromptText)
